import React, { useContext, useEffect, useState } from "react";
import { Modal, TextInput, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import axios from "axios";
import GlobalContext from '../connections/GlobalContext';
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import DataTable from "react-data-table-component";
import Select from 'react-select';
import { ArrowLeft } from "lucide-react";
import { Table, Button } from "flowbite-react";
import { use } from "react";
import { FaArrowLeft } from 'react-icons/fa';
import engineGif from "../image/engine.gif";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Spares = () => {
  const [open, setOpen] = useState(false);
  const { globalValue } = useContext(GlobalContext);
  const [spares, setSpares] = useState([]);
  const [spareName, setSpareName] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [mode, setMode] = useState("add");
  const [editId, setEditId] = useState(null);

  const [flag_branch, setFlag_branch] = useState(sessionStorage.getItem("branch"));
  const [flag_berror, setFlag_berror] = useState("");
  const [show_spare_request, setSHow_request] = useState(false);

  const [loading, setLoading] = useState(false);
  const [common_spare, setCommon_spare] = useState(false);

  const [brand, setBrand] = useState([]);
  const [model, setModel] = useState([]);
  const [step, setStep] = useState(1);

  const [mrp, setMrp] = useState("");
  const [rate, setRate] = useState("");
  const [gst, setGst] = useState("");
  const [entries, setEntries] = useState([]);

  const [additionalPrices, setAdditionalPrices] = useState({});
  const [showAdditional, setShowAdditional] = useState(false);
  const [selectedEntryKey, setSelectedEntryKey] = useState("");
  const [addMrp, setAddMrp] = useState("");
  const [addGst, setAddGst] = useState("");
  const [addRate, setAddRate] = useState("");
  const [editIndex, setEditIndex] = useState(null);

  const handleNext = () => setStep(2);
  const handleBack = () => setStep(1);



  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(spares);
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = sessionStorage.getItem("spares_current_page");
    return saved ? parseInt(saved) : 1;
  });
  const [perPage, setPerPage] = useState(10);
  const [viewedSpares, setViewedSpares] = useState([]);
  const [blinkingSpareId, setBlinkingSpareId] = useState(null);


  useEffect(() => {
    if (mrp && gst) {
      const mrpVal = parseFloat(mrp);
      const gstVal = parseFloat(gst);
      const calculatedRate = (mrpVal / (1 + (gstVal / 100))).toFixed(2);
      setRate(calculatedRate);
    } else if (mrp) {
      setRate(mrp);
    } else {
      setRate("");
    }
  }, [mrp, gst]);

  useEffect(() => {
    if (addMrp && addGst) {
      const mrpVal = parseFloat(addMrp);
      const gstVal = parseFloat(addGst);
      const calculatedRate = (mrpVal / (1 + (gstVal / 100))).toFixed(2);
      setAddRate(calculatedRate);
    } else if (addMrp) {
      setAddRate(addMrp);
    } else {
      setAddRate("");
    }
  }, [addMrp, addGst]);

  useEffect(() => {
    const filteredData = spares.filter((branch) =>
      branch.spare_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, spares]);

  const RetriveRecords = async () => {
    try {
      const response = await axios.post(`${globalValue}/retrivedetails`, {
        spare_id: sessionStorage.getItem("spare_id"),
      });
      const row = response.data[0];
      if (response.data) {
        setMode("edit");
        setStep(2);
        setEditId(row.spare_id);
        setSpareName(row.spare_name);
        setServiceId(row.service_id);
        setQuantity(row.quantity);
        setFlag_branch(row.branch);
        setEntries(row.model);
        setAdditionalPrices(() => {
          const map = {};
          (row.multi_price || []).forEach((mp) => {
            const key = `${mp.brand}||${mp.model}`;
            map[key] = Array.isArray(mp.prices)
              ? mp.prices.map((p) => ({ mrp: p.mrp, gst: p.gst, rate: p.rate }))
              : [];
          });
          return map;
        });
        setOpen(true);
        setBrand([]);
        setModel([]);
        setMrp("");
        setRate("");
        setGst("");

      }
      sessionStorage.setItem("status", 0);
      sessionStorage.setItem("spare_id", "");

    } catch (error) {

    }
  }

  useEffect(() => {
    if (parseInt(sessionStorage.getItem("status")) === 1) {
      RetriveRecords();
    }

  }, []);

  const handleAddEntry = () => {
    if (!brand.length || !model.length || !mrp || !rate || !gst) return;

    const newEntries = [];

    brand.forEach((selectedBrand) => {
      const validModels = modals.filter((item) => item[1] === selectedBrand[0]);
      model.forEach((selectedModel) => {
        if (validModels.some((validModel) => validModel[2] === selectedModel)) {
          newEntries.push({ brand: selectedBrand[0], model: selectedModel, mrp, rate, gst, quantity: 0 });
        }
      });
    });


    setEntries([...entries, ...newEntries]);
    setBrand([]);
    setModel([]);
    setMrp("");
    setRate("");
    setGst("");
  };







  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/spares`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        }
      });
      setSpares(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };



  const [branches, setBranches] = useState([]);
  const fetchData1 = () => {
    setLoading(true);
    fetch(globalValue + "/branches", {
      method: "GET",
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((dat) => {
        setBranches(dat);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      }).finally(() => setLoading(false))
  };

  const [requested_spare, setRequested_spares] = useState([]);
  const fetchRequested_spares = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/request_spare`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        }
      });
      setRequested_spares(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  };




  const handleApprove = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this spare request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(`${globalValue}/approve_spare`, { id }, {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          });

          if (response.data === "success") {
            Swal.fire({
              icon: "success",
              title: "Spare transferred successfully",
            });
            setSHow_request(false);
            fetchData();
            // fetchDat();
            fetchData1();
            fetchRequested_spares();
          } else {
            Swal.fire({
              icon: "warning",
              title: response.data.message,
            });
          }
        } catch (error) {
          console.error("Error approving spare:", error);
        }
        finally {
          setLoading(false);
        }
      }
    });
  };

  const handleState = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the state of this spare request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Change State!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(`${globalValue}/state_spare`, { id }, {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          });

          if (response.data === "success") {
            Swal.fire({
              icon: "success",
              title: "Spare state changed successfully",
            });
            setSHow_request(false);
            fetchData();
            // fetchDat();
            fetchData1();
            fetchRequested_spares();
          } else {
            Swal.fire({
              icon: "warning",
              title: response.data.message,
            });
          }
        } catch (error) {
          console.error("Error changing spare state:", error);
        }
        finally {
          setLoading(false);
        }
      }
    });
  };


  const [brands, setBrands] = useState([]);
  const fetchBrand = () => {
    setLoading(true);
    fetch(globalValue + "/v_brand", {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setBrands(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      }).finally(() => setLoading(false))
  };


  const [modals, setModals] = useState([]);
  const fetchmodal = () => {
    fetch(globalValue + "/v_modal", {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      }
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setModals(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const flattenedBrands = brand.flat();

  const filteredModels = modals
    .filter((item) => flattenedBrands.includes(item[1]))
    .map((item) => ({
      value: item[2],
      label: item[2],
    }));




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "spareName") setSpareName(value);
    else if (name === "serviceId") setServiceId(value);
    else if (name === "quantity") setQuantity(value);

    if (name === "branch") setFlag_branch(value);
  };

  const handleSubmit = async () => {
    if (!spareName || (!common_spare && entries.length === 0)) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "All fields are required.",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoading(true);

    const finalEntries = common_spare
      ? [{
        brand: "common",
        model: "common",
        mrp,
        rate,
        gst,
        quantity: temp_quat,
      }]
      : entries;

    const additionalPayload = Object.entries(additionalPrices).map(([key, prices]) => {
      const [b, m] = key.split("||");
      return { brand: b, model: m, prices };
    });

    try {
      const url = mode === "add"
        ? `${globalValue}/spare_submit`
        : `${globalValue}/spare_edit`;

      const payload = {
        spare_name: spareName,
        service_id: serviceId,
        quantity: 0,
        entries: finalEntries,
        additional: additionalPayload,
        ...(mode === "edit" && { id: editId, flag_branch })
      };

      const response = await axios.post(url, payload, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });

      if (response.data === "success") {
        Swal.fire({
          icon: "success",
          title: mode === "add" ? "Added!" : "Updated!",
          text: `Spare ${mode === "add" ? "added" : "updated"} successfully.`,
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire(
          "Error",
          response.data.message,
          "error"
        );
      }

      setOpen(false);
      fetchData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.error || "Something went wrong!",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this spare? This will delete corresponding spares in all branches and this action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(`${globalValue}/spare_delete`, { id }, {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          });
          if (response.data === "success") {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: "Spare deleted successfully.",
              confirmButtonText: "OK",
            });
            fetchData();
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error.response?.data?.error || "Something went wrong!",
            confirmButtonText: "OK",
          });
        }
        finally {
          setLoading(false);
        }
      }

    });
  };

  useEffect(() => {
    fetchData();
    fetchData1();
    fetchRequested_spares();
    fetchBrand();
    fetchmodal();
  }, []);
  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
        width: '100%',
        border: "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor: 'rgb(226, 232, 240)',
        color: 'black',
        fontWeight: 'bold',
      },
    },
  };

  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [temp_spare_id, setTemp_spare_id] = useState("");
  const [model_data, setModel_data] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [reportData, setReportData] = useState(null);

  const [searchTerm1, setSearchTerm1] = useState("");
  const [filtered1, setFiltered1] = useState(model_data);

  useEffect(() => {
    const filteredData = model_data.filter((branch) =>
    (branch["brand"]?.toLowerCase().includes(searchTerm1.toLowerCase()) ||
      branch["model"]?.toLowerCase().includes(searchTerm1.toLowerCase()))
    );
    setFiltered1(filteredData);
  }, [searchTerm1, model_data]);

  const [temp_quat, setTemp_quat] = useState(0);

  const columns = [
    {
      name: "Spare ID",
      selector: (row) => row.spare_id || "N/A",
      sortable: true,
    },
    {
      name: "Spare Name",
      selector: (row) => row.spare_name || "N/A",
      sortable: true,
    },
    {
      name: "Total Quantity",
      selector: (row) => {
        if (!Array.isArray(row.model)) return "Invalid Data";
        return row.model.reduce((total, item) => total + (item.quantity || 0), 0);
      },
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => {
        if (!Array.isArray(row.model)) return "₹0.00";
        const total = row.model.reduce((sum, item) => {
          const mrp = parseFloat(item.mrp) || 0;
          const qty = parseFloat(item.quantity) || 0;
          return sum + (mrp * qty);
        }, 0);
        return `₹${total.toFixed(2)}`;
      },
      sortable: true,
    },
    {
      name: "Date and Time",
      selector: (row) => {
        if (!row.date) return "N/A";
        const date = new Date(row.date);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      },
      sortable: true,
    },
    {
      name: "Actions",

      cell: (row) => (
        <div className="flex gap-4 ms-1">

          <button
            className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
            onClick={() => {
              setShow2(true);
              setModel_data(row.model);
              setTemp_spare_id(row.spare_id);
              console.log(row.model);
              // Clear old viewed spares and set only this one as viewed
              const newViewed = [row.spare_id];
              setViewedSpares(newViewed);
              sessionStorage.setItem("viewed_spares", JSON.stringify(newViewed));
              // Start blinking effect
              setBlinkingSpareId(row.spare_id);
              // Stop blinking after 3 seconds
              setTimeout(() => {
                setBlinkingSpareId(null);
              }, 3000);
            }}
          >
            <i className="fa fa-eye"></i>
          </button>
          {sessionStorage.getItem("position") === "superadmin" ? <button
            onClick={() => {
              setMode("edit");
              setStep(2);
              setEditId(row.spare_id);
              setSpareName(row.spare_name);
              setServiceId(row.service_id);
              setQuantity(row.quantity);
              setFlag_branch(row.branch);
              console.log(row.model)
              setEntries(row.model);
              setAdditionalPrices(() => {
                const map = {};
                (row.multi_price || []).forEach((mp) => {
                  const key = `${mp.brand}||${mp.model}`;
                  map[key] = Array.isArray(mp.prices)
                    ? mp.prices.map((p) => ({ mrp: p.mrp, gst: p.gst, rate: p.rate }))
                    : [];
                });
                return map;
              });
              setTemp_quat(row.model[0]?.quantity || 0);

              setOpen(true);
              setBrand([]);
              setModel([]);

              if (row.model[0]?.brand === "common" && row.model[0]?.model === "common") {
                setCommon_spare(true);
                setMrp(row.model[0]?.mrp || "");
                setRate(row.model[0]?.rate || "");
                setGst(row.model[0]?.gst || "");
              } else {
                setCommon_spare(false);
                setMrp("");
                setRate("");
                setGst("");
              }
            }}
            className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
          >
            <i className="fa fa-edit"></i>
          </button> : null}
          {sessionStorage.getItem("position") === "superadmin" && row.model.reduce((total, item) => total + (item.quantity || 0), 0) == 0 ? <button
            onClick={() => handleDelete(row.spare_id)}
            className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
          >
            <i className="fa fa-trash"></i>
          </button> : null}
        </div>
      ),
    },
  ];
  const [mode1, setMode1] = useState("add");

  const [quantities, setQuantities] = useState({});
  const [quantities1, setQuantities1] = useState({});
  useEffect(() => {
    const initialQuantities = {};
    model_data.forEach((item) => {
      initialQuantities[item.model] = item.quantity ?? 0;
    });
    setQuantities(initialQuantities);
  }, [model_data]);



  const handleQuantityChange = (model, value) => {
    console.log(model, value)
    setQuantities((prev) => ({ ...prev, [model]: value }));

    setQuantity_modal(false);
  };

  const handleSubmit1 = async () => {
    const updatedFields = model_data
      .filter((item) => quantities[item.model] !== item.quantity)
      .map((item) => ({ brand: item.brand, model: item.model, quantity: quantities[item.model] }));
    setLoading(true);
    try {
      const response = await axios.post(`${globalValue}/add_quantity_spare`, {
        updatedFields,
        branch: sessionStorage.getItem("branch"),
        temp_spare_id
      }, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      })
      if (response.data === "success") {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Spare Quantity Updated successfully.",
          confirmButtonText: "OK",
        });
        fetchData();
        setShow2(false);
      }
    } catch (error) {

    }
    finally {
      setLoading(false);
    }
  };

  const checkDuplicate = async (spare_name) => {
    try {
      const response = await axios.post(`${globalValue}/check_duplicate`, {
        spare_name,
      })
      return response.data;
    } catch (error) {
      console.log(error)
    }

  }

  const fetchReport = async (brand, model) => {
    try {
      const response = await axios.post(`${globalValue}/spare_report`, {
        spare_id: temp_spare_id,
        brand,
        model,
        branch: sessionStorage.getItem("branch"),
      }, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setReportData(response.data);
      setShowReport(true);
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "—";
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch {
      return dateStr;
    }
  };

  const calculateEntriesWithBalance = (entries) => {
    let opening = 0;
    let totalDebit = 0;
    let totalCredit = 0;
    try {
      const result = entries.map((entry) => {
        const debit = entry.type === "debit" ? (Number(entry.amount) || 0) : 0;
        const credit = entry.type === "credit" ? (Number(entry.amount) || 0) : 0;
        const closing = opening + debit - credit;
        
        totalDebit += debit;
        totalCredit += credit;
        
        const row = {
          date: entry.date,
          description: entry.description || "",
          quantity: Number(entry.quantity) || 0,
          opening: opening,
          credit: credit,
          debit: debit,
          closing: closing
        };
        opening = closing;
        return row;
      });
      return { entries: result, totalDebit, totalCredit, finalClosing: opening };
    } catch (error) {
      console.error("Error calculating entries:", error);
      return { entries: [], totalDebit: 0, totalCredit: 0, finalClosing: 0 };
    }
  };

  const handleDownloadPDF = () => {
    if (!reportData || !reportData.entries) return;
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Spare Report", 14, 15);
    
    const { entries: entriesWithBalance, totalDebit, totalCredit, finalClosing } = calculateEntriesWithBalance(reportData.entries);
    const tableBody = entriesWithBalance.map((entry) => [
      formatDate(entry.date),
      entry.description,
      entry.quantity,
      entry.opening.toFixed(2),
      entry.credit.toFixed(2),
      entry.debit.toFixed(2),
      entry.closing.toFixed(2)
    ]);
    
    // Add totals row
    tableBody.push([
      "",
      "Total",
      "",
      "",
      totalCredit.toFixed(2),
      totalDebit.toFixed(2),
      finalClosing.toFixed(2)
    ]);

    autoTable(doc, {
      head: [["Date", "Description", "Quantity", "Opening (₹)", "Credit (₹)", "Debit (₹)", "Closing (₹)"]],
      body: tableBody,
      startY: 25,
      styles: { fontSize: 10, halign: "center" },
      headStyles: { fillColor: [66, 66, 66], halign: "center" },
      columnStyles: { 1: { halign: "left" } },
    });

    doc.save("spare_report.pdf");
  };

  const [quantity_modal, setQuantity_modal] = useState(false);
  const [temp_model, setTemp_model] = useState("");
  const [temp_quantity, setTemp_quantity] = useState("");

  return (
    <div>
      <style>{`
        @keyframes blink {
          0%, 100% { 
            background-color: #3b82f6 !important;
            color: white !important;
            box-shadow: 0 0 10px rgba(59, 130, 246, 0.5) !important;
          }
          50% { 
            background-color: white !important;
            color: inherit !important;
            box-shadow: none !important;
          }
        }
      `}</style>
      <div className={`md:ml-[250px] w-full md:w-[calc(100%-250px)]  mt-16 h-[92vh] flex justify-center items-center box-border`}>
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
          {!show2 ? <>
            <div className="w-full flex justify-between text-gray-600">
              <Head_data data="Manage Spares" font="" size="3xl" />
              <div className="div flex gap-2">
                {sessionStorage.getItem("position") === "superadmin" || sessionStorage.getItem("position") === "admin" ? <button
                  onClick={() => { setSHow_request(true); }}
                  className="px-4 py-2 text-black border border-gray-500 bg-gray-300 rounded hover:bg-gray-700 hover:text-gray-200 md:mt-2">Requests</button> : null}
                {sessionStorage.getItem("position") === "superadmin" ? <button
                  onClick={() => {
                    setMode("add");
                    setSpareName("");
                    setServiceId("");
                    setQuantity("");

                    setMrp("");
                    setEntries([]);
                    setGst("");
                    setRate("");
                    setAdditionalPrices({});
                    setStep(1);
                    setFlag_branch(sessionStorage.getItem("branch"));
                    setOpen(true);
                    setCommon_spare(false)
                  }}
                  className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
                >
                  Add Spare
                </button> : null}
              </div>
            </div>

            <input
              type="text"
              placeholder="Search by spare name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />
            <div className="py-6 md:px-4">
              <DataTable
                columns={columns}
                data={filtered}
                customStyles={customStyles}
                pagination
                paginationPerPage={perPage}
                paginationDefaultPage={currentPage}
                onChangePage={(page) => {
                  setCurrentPage(page);
                  sessionStorage.setItem("spares_current_page", page.toString());
                }}
                onChangeRowsPerPage={(rows, page) => {
                  setPerPage(rows);
                  setCurrentPage(page);
                  sessionStorage.setItem("spares_current_page", page.toString());
                }}
                conditionalRowStyles={[
                  {
                    when: (row) => row.spare_id === blinkingSpareId,
                    style: {
                      animation: "blink 0.2s ease-in-out infinite",
                      transition: "all 0.2s ease",
                      zIndex: 100,
                    },
                  },
                  {
                    when: (row) => viewedSpares.includes(row.spare_id),
                    style: {
                      backgroundColor: "rgba(209, 250, 229, 0.5)",
                    },
                  },
                ]}
              />
              <div className="flex justify-end mt-4">
                <div className="px-4 py-2 bg-gray-100 rounded-lg">
                  <span className="font-semibold text-gray-800">Overall Total Amount: </span>
                  <span className="font-bold text-lg text-blue-600">
                    ₹{filtered.reduce((total, row) => {
                      if (!Array.isArray(row.model)) return total;
                      return total + row.model.reduce((sum, item) => {
                        const mrp = parseFloat(item.mrp) || 0;
                        const qty = parseFloat(item.quantity) || 0;
                        return sum + (mrp * qty);
                      }, 0);
                    }, 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </> :
            <div>
              <div className="flex gap-6 mb-4">
                <button
                  onClick={() => setShow2(false)}
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                >
                  <FaArrowLeft className="w-4 h-4" />
                </button>
                <h2 className="text-xl font-semibold">Spare Info</h2>
              </div>

              <input
                type="text"
                placeholder="Search branch by name"
                value={searchTerm1}
                onChange={(e) => setSearchTerm1(e.target.value)}
                className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
              />


              <div className="overflow-x-auto h-[500px] border border-gray-300 rounded-md shadow-md">
                <table className="w-full">
                  <thead className="bg-gray-100 border-b">
                    <tr>
                      <th className="p-3 border-r">Brand</th>
                      <th className="p-3 border-r">Model</th>
                      <th className="p-3 border-r">GST</th>
                      <th className="p-3 border-r">MRP</th>
                      <th className="p-3 border-r">Rate</th>
                      <th className="p-3">Quantity</th>
                      <th className="p-3">Action</th>
                      <th className="p-3">Report</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered1.map((item, index) => (
                      <tr key={index} className="border-b text-center">
                        <td className="p-3 border-r">{item.brand}</td>
                        <td className="p-3 border-r">{item.model}</td>
                        <td className="p-3 border-r">{item.gst}%</td>
                        <td className="p-3 border-r">₹{item.mrp}</td>
                        <td className="p-3 border-r">₹{(parseFloat(item.mrp) / (1 + (parseFloat(item.gst) || 0) / 100)).toFixed(2)}</td>
                        <td className="p-3 border-r">{quantities[item.model]}</td>
                        <td className="p-3 border-r">

                          {sessionStorage.getItem("position") === "admin" && quantities[item.model] === 0 || sessionStorage.getItem("position") === "superadmin" ?
                            <button onClick={() => {
                              setTemp_model(item.model)
                              setTemp_quantity(quantities[item.model]);
                              setQuantity_modal(true);
                            }}>
                              <i className="fa fa-edit">

                              </i>
                            </button> : null}
                        </td>
                        <td className="p-3">
                          <button
                            onClick={() => fetchReport(item.brand, item.model)}
                            className="px-3 py-1 text-white bg-green-600 rounded hover:bg-green-700"
                          >
                            Report
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-center mt-4">
                <button
                  onClick={handleSubmit1}
                  className="px-6 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                >
                  Submit
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <Modal show={quantity_modal} onClose={() => setQuantity_modal(false)} size="xl">
        <Modal.Header className="flowbite-modal-h">
          Update Spare for {temp_model}
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <label htmlFor="">Quantity :</label>
          <input
            type="number"
            value={temp_quantity}
            onChange={(e) => setTemp_quantity(e.target.value)}

            className="border border-gray-300 p-2 mt-2 rounded w-full "

          />

        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          <button
            onClick={() => handleQuantityChange(temp_model, Number(temp_quantity))}
            className="px-6 py-2 ms-auto text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={open} onClose={() => setOpen(false)} size="4xl">
        <Modal.Header className="flowbite-modal-h">
          {step === 2 && (
            <button onClick={handleBack} className="mr-2">
              <ArrowLeft size={20} />
            </button>
          )}
          {mode === "add" ? "Add Spare" : "Edit Spare"}
        </Modal.Header>


        <Modal.Body className="flowbite-modal-h">
          <form className="space-y-6">
            {step === 1 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <div>
                  <Label htmlFor="spareName" value="Spare Name" />
                  <TextInput
                    id="spareName"
                    name="spareName"
                    placeholder="Spare name"
                    value={spareName}
                    onChange={handleInputChange}
                    required
                    color="white"
                  />
                </div>


                <div className="flex items-center mt-6">
                  <input
                    id="commonSpare"
                    type="checkbox"
                    checked={common_spare}
                    onChange={(e) => setCommon_spare(e.target.checked)}
                    className="mr-2"
                  />
                  <label htmlFor="commonSpare" className="text-sm font-medium text-gray-900">
                    Common Spare
                  </label>
                </div>
              </div>


            ) : (
              <>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                  {!common_spare && <div>
                    <Label htmlFor="brand" value="Brand" />
                    <Select
                      id="brand"
                      name="brand"
                      value={brand}
                      onChange={(selectedOptions) => {
                        setBrand(selectedOptions.map(option => option));
                        console.log("selected_options::", modals, brand);
                      }}
                      options={brands}
                      getOptionLabel={(e) => e}
                      getOptionValue={(e) => e}
                      isDisabled={mode1 === "edit"}
                      isSearchable
                      required
                      isMulti
                      color="white"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      maxMenuHeight={130}

                    />

                  </div>}

                  {!common_spare && <div>
                    <Label htmlFor="model" value="Model" />
                    <Select
                      id="model"
                      name="model"
                      value={filteredModels.filter(option => model.includes(option.value))}
                      onChange={(selectedOptions) => setModel(selectedOptions.map(option => option.value))}
                      options={filteredModels}
                      isDisabled={mode1 === "edit"}
                      isSearchable
                      isMulti
                      color="white"
                    />

                  </div>}

                  <div>
                    <Label htmlFor="mrp" value="MRP" />
                    <TextInput
                      id="mrp"
                      name="mrp"
                      type="number"

                      value={mrp}
                      onChange={(e) => setMrp(e.target.value)}
                      required
                      color="white"
                    />
                  </div>
                  <div>
                    <Label htmlFor="rate" value="Rate" />
                    <TextInput
                      id="rate"
                      name="rate"
                      type="number"
                      placeholder="Calculated Rate"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                      readOnly
                      required
                      color="white"
                    />
                  </div>
                  <div>
                    <Label htmlFor="gst" value="GST%" />
                    <TextInput
                      id="gst"
                      name="gst"
                      type="number"
                      color="white"
                      value={gst}
                      onChange={(e) => setGst(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {common_spare && (
                  <Button
                    onClick={() => {
                      setSelectedEntryKey("common||common");
                      setShowAdditional(true);
                      setAddMrp("");
                      setAddGst("");
                      setAddRate("");
                      setEditIndex(null);
                    }}
                    className="mt-3"
                  >
                    Add Prices
                  </Button>
                )}

                {!common_spare && <>
                  {mode1 !== "edit" ? <Button onClick={handleAddEntry} className="mt-3">Add</Button> :
                    <Button
                      onClick={() => {
                        if (!brand || !model || !mrp || !rate || !gst) return;

                        setEntries((prevEntries) =>
                          prevEntries.map((entry) =>
                            entry.brand === brand[0] && entry.model === model[0]
                              ? { ...entry, mrp, rate, gst }
                              : entry
                          )
                        );
                        console.log(brand, model, mrp, rate, gst)

                        setBrand([]);
                        setModel([]);
                        setMrp("");
                        setRate("");
                        setGst("");
                        setMode1("add");
                      }}
                    >
                      Update
                    </Button>
                  }</>}

                {!common_spare && <div className="mt-6 h-48  overflow-y-auto">
                  <table className="w-full border-collapse border border-gray-300 shadow-sm">

                    <thead className="bg-gray-100 border-b border-gray-300">
                      <tr>
                        <th className="p-3 text-left text-gray-900 border-r border-gray-300">Brand</th>
                        <th className="p-3 text-left text-gray-900 border-r border-gray-300">Model</th>
                        <th className="p-3 text-left text-gray-900 border-r border-gray-300">MRP</th>
                        <th className="p-3 text-left text-gray-900 border-r border-gray-300">Rate</th>
                        <th className="p-3 text-left text-gray-900 border-r border-gray-300">GST</th>

                        <th className="p-3 text-left text-gray-900 text-center">Action</th>

                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-300">
                      {entries.map((entry, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="p-3 border-r border-gray-300">{entry.brand}</td>
                          <td className="p-3 border-r border-gray-300">{entry.model}</td>
                          <td className="p-3 border-r border-gray-300">Rs.{entry.mrp}</td>
                          <td className="p-3 border-r border-gray-300">Rs.{(parseFloat(entry.mrp) / (1 + (parseFloat(entry.gst) || 0) / 100)).toFixed(2)}</td>
                          <td className="p-3 border-r border-gray-300">{entry.gst}%</td>

                          <td className="p-3 flex">

                            <div className="flex justify-center">
                              <button
                                onClick={(e) => {
                                  setBrand([entry.brand]);
                                  setMode1("edit");
                                  setModel([entry.model]);
                                  setRate(entry.rate);
                                  setGst(entry.gst);
                                  setMrp(entry.mrp);
                                  e.preventDefault();

                                }}
                                className="p-2 ms-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                            </div>

                            {!common_spare && <div className="flex justify-center">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  const key = `${entry.brand}||${entry.model}`;
                                  setSelectedEntryKey(key);
                                  setShowAdditional(true);
                                  setAddMrp("");
                                  setAddGst("");
                                  setAddRate("");
                                  setEditIndex(null);
                                }}
                                className="p-2 ms-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
                              >
                                <i className="fa fa-eye"></i>
                              </button>
                            </div>}

                            <div className="flex justify-center">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "This process may delete the same entry in other branch as well.",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#d33",
                                    cancelButtonColor: "#3085d6",
                                    confirmButtonText: "Yes, delete it",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      const newEntries = entries.filter((_, i) => i !== index);
                                      setEntries(newEntries);
                                    }
                                  });
                                }}
                                className="p-2 ms-2 text-white border bg-red-500 hover:bg-yellow-800 rounded-md shadow-xl"
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>


                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>

                </div>}
              </>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          {step === 1 ? (
            <Button_submit onClick={async () => {
              const response = await checkDuplicate(spareName)
              if (response === "success") {
                handleNext();
              }
              else {
                Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: 'Spare name already exists.',
                  confirmButtonText: "OK",
                });
              }
            }} data="Continue" aditional="ms-auto" />

          ) : (
            <Button_submit
              onClick={handleSubmit}
              data={`${mode === "add" ? "Submit" : "Update"}`}
              type="submit"
              aditional="ms-auto"
            />
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={showAdditional} onClose={() => { setShowAdditional(false); setEditIndex(null); }} size="xl">
        <Modal.Header className="flowbite-modal-h">
          Add Prices
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            <div>
              <Label htmlFor="addMrp" value="MRP" />
              <TextInput
                id="addMrp"
                name="addMrp"
                type="number"
                value={addMrp}
                onChange={(e) => setAddMrp(e.target.value)}
                required
                color="white"
              />
            </div>
            <div>
              <Label htmlFor="addRate" value="Rate" />
              <TextInput
                id="addRate"
                name="addRate"
                type="number"
                placeholder="Calculated Rate"
                value={addRate}
                onChange={(e) => setAddRate(e.target.value)}
                readOnly
                required
                color="white"
              />
            </div>
            <div>
              <Label htmlFor="addGst" value="GST%" />
              <TextInput
                id="addGst"
                name="addGst"
                type="number"
                color="white"
                value={addGst}
                onChange={(e) => setAddGst(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mt-4">
            <table className="w-full border-collapse border border-gray-300 shadow-sm">
              <thead className="bg-gray-100 border-b border-gray-300">
                <tr>
                  <th className="p-3 text-left border-r border-gray-300">MRP</th>
                  <th className="p-3 text-left border-r border-gray-300">Rate</th>
                  <th className="p-3 text-left border-r border-gray-300">GST</th>
                  <th className="p-3 text-left text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-300">
                {(additionalPrices[selectedEntryKey] || []).map((p, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="p-3 border-r border-gray-300">Rs.{p.mrp}</td>
                    <td className="p-3 border-r border-gray-300">Rs.{(parseFloat(p.mrp) / (1 + (parseFloat(p.gst) || 0) / 100)).toFixed(2)}</td>
                    <td className="p-3 border-r border-gray-300">{p.gst}%</td>
                    <td className="p-3 flex">
                      <button
                        onClick={() => {
                          setAddMrp(p.mrp);
                          setAddGst(p.gst);
                          setAddRate(p.rate);
                          setEditIndex(idx);
                        }}
                        className="p-2 ms-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <button
                        onClick={() => {
                          const list = (additionalPrices[selectedEntryKey] || []).filter((_, i) => i !== idx);
                          setAdditionalPrices(prev => ({ ...prev, [selectedEntryKey]: list }));
                          if (editIndex === idx) setEditIndex(null);
                        }}
                        className="p-2 ms-2 text-white border bg-red-500 hover:bg-yellow-800 rounded-md shadow-xl"
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          <button
            onClick={() => {
              if (!addMrp || !addGst || !addRate || !selectedEntryKey) return;
              setAdditionalPrices(prev => {
                const existing = prev[selectedEntryKey] ? [...prev[selectedEntryKey]] : [];
                if (editIndex !== null && editIndex >= 0) {
                  existing[editIndex] = { mrp: addMrp, gst: addGst, rate: addRate };
                } else {
                  existing.push({ mrp: addMrp, gst: addGst, rate: addRate });
                }
                return { ...prev, [selectedEntryKey]: existing };
              });
              setAddMrp("");
              setAddGst("");
              setAddRate("");
              setEditIndex(null);
            }}
            className="px-6 py-2 ms-auto text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            {editIndex !== null ? "Update Price" : "Add Price"}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show_spare_request} onClose={() => setSHow_request(false)} size="4xl">
        <Modal.Header className="flowbite-modal-h">Request for Spares</Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          {requested_spare.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300 text-sm">
                <thead>
                  <tr className="bg-gray-100 text-xs">

                    <th className="border border-gray-300 p-2">Spare Name</th>
                    <th className="border border-gray-300 p-2">Brand</th>
                    <th className="border border-gray-300 p-2">Model</th>
                    <th className="border border-gray-300 p-2">Requested Spare</th>
                    <th className="border border-gray-300 p-2">From</th>
                    <th className="border border-gray-300 p-2">To</th>
                    <th className="border border-gray-300 p-2">Date</th>
                    <th className="border border-gray-300 p-2">Quantity</th>
                    <th className="border border-gray-300 p-2">Mobile No</th>
                    <th className="border border-gray-300 p-2">Status</th>
                    {sessionStorage.getItem("position") === "superadmin" ? (
                      <th className="border border-gray-300 p-2">Approval</th>
                    ) : null}
                  </tr>
                </thead>

                <tbody>
                  {requested_spare.map((spare, index) => (
                    <tr key={index} className="text-center">

                      <td className="border border-gray-300 p-2">{spare.spare_name}</td>
                      <td className="border border-gray-300 p-2">{spare.brand}</td>
                      <td className="border border-gray-300 p-2">{spare.model}</td>
                      <td className="border border-gray-300 p-2">{spare.requested_spare_name}</td>
                      <td className="border border-gray-300 p-2">{spare.from_branch_name}</td>
                      <td className="border border-gray-300 p-2">{spare.to_branch_name}</td>
                      <td className="border border-gray-300 p-2">
                        {spare.date ? new Date(spare.date).toLocaleDateString("en-GB") : ""}
                      </td>
                      <td className="border border-gray-300 p-2">{spare.quantity}</td>
                      <td className="border border-gray-300 p-2">{spare.mobile_no}</td>
                      {spare.approval === "1" ? (
                        <td className="border border-gray-300 p-2">
                          {spare.status === "unapproved" ? (
                            <button
                              className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                              onClick={() => handleApprove(spare.id)}
                            >
                              Approve
                            </button>
                          ) : (
                            <span className="text-green-500 font-semibold">Approved ✅</span>
                          )}
                        </td>
                      ) : (
                        <td className="border border-gray-300 p-2">Wait</td>
                      )}
                      {sessionStorage.getItem("position") === "superadmin" ? (
                        <td className="border border-gray-300 p-2">
                          {spare.approval === "0" ? (
                            <button
                              className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                              onClick={() => handleState(spare.id)}
                            >
                              Allow
                            </button>
                          ) : null}
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center text-gray-500">No spare requests available.</p>
          )}

        </Modal.Body>
      </Modal>

      <Modal show={showReport} onClose={() => setShowReport(false)} size="4xl">
        <Modal.Header className="flowbite-modal-h">
          Spare Report
          <button
            onClick={handleDownloadPDF}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 ml-auto"
          >
            <i className="fa fa-download mr-2"></i>Download PDF
          </button>
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          {reportData ? (
            <div className="space-y-4">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100 text-xs">
                      <th className="border border-gray-300 p-2">Date</th>
                      <th className="border border-gray-300 p-2">Description</th>
                      <th className="border border-gray-300 p-2">Quantity</th>
                      <th className="border border-gray-300 p-2">Opening (₹)</th>
                      <th className="border border-gray-300 p-2">Credit (₹)</th>
                      <th className="border border-gray-300 p-2">Debit (₹)</th>
                      <th className="border border-gray-300 p-2">Closing (₹)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const { entries: entriesWithBalance, totalDebit, totalCredit, finalClosing } = calculateEntriesWithBalance(reportData.entries);
                      return (
                        <>
                          {entriesWithBalance.map((entry, index) => (
                            <tr key={index} className="text-center">
                              <td className="border border-gray-300 p-2">{formatDate(entry.date)}</td>
                              <td className="border border-gray-300 p-2 text-left">{entry.description}</td>
                              <td className="border border-gray-300 p-2">{entry.quantity}</td>
                              <td className="border border-gray-300 p-2">{entry.opening.toFixed(2)}</td>
                              <td className="border border-gray-300 p-2">{entry.credit.toFixed(2)}</td>
                              <td className="border border-gray-300 p-2">{entry.debit.toFixed(2)}</td>
                              <td className="border border-gray-300 p-2">{entry.closing.toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr className="text-center font-semibold bg-gray-100">
                            <td className="border border-gray-300 p-2"></td>
                            <td className="border border-gray-300 p-2 text-left">Total</td>
                            <td className="border border-gray-300 p-2"></td>
                            <td className="border border-gray-300 p-2"></td>
                            <td className="border border-gray-300 p-2">{totalCredit.toFixed(2)}</td>
                            <td className="border border-gray-300 p-2">{totalDebit.toFixed(2)}</td>
                            <td className="border border-gray-300 p-2">{finalClosing.toFixed(2)}</td>
                          </tr>
                        </>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className="text-center text-gray-500">Loading report...</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Spares;
